export default __webpack_public_path__ + "static/media/household-icon.a2a9b2d9.svg";